import request from '@/utils/request'

/**
 * Lista dei record "lost" con paginazione e filtri.
 * Il backend espone GET /lost/list
 */
export function getLostList (filters, pagination) {
  // normalizza i filtri date da-a (stesso pattern usato in disposed, returned, ecc.)
  for (var t in filters) {
    if (t.indexOf('_$$$_from') > -1) {
      var oldval1 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_from')[0]] = '>=' + oldval1
    }
    if (t.indexOf('_$$$_to') > -1) {
      var oldval2 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_to')[0]] = '<=' + oldval2
    }
  }
  return request({
    url: '/lost/list',
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    }
  })
}

/**
 * Elenco delle siterequests filtrate per protocol, site (usato nell'autocomplete type_id).
 * GET /siterequest  con x-filters { protocol_id, site_id }
 */
export function getSiteRequestsForLost (search, protocol_id, site_id) {
  const filters = { protocol_id, site_id }
  if (search) filters['protocol.name'] = `%${search}%`
  return request({
    url: '/siterequest',
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 20, page: 1 })
    }
  })
}

/**
 * Elenco dei "returned" filtrati per protocol, site (usato nell'autocomplete type_id).
 * GET /returned  con x-filters { protocol_id, site_id }
 */
export function getReturnedForLost (search, protocol_id, site_id) {
  const filters = { protocol_id, site_id }
  if (search) filters['protocol.name'] = `%${search}%`
  return request({
    url: '/returned',
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 20, page: 1 })
    }
  })
}

/**
 * Verifica l'esistenza di un record siterequest o returned e ne restituisce
 * protocol_id e site_id per il controllo di coerenza lato frontend.
 * GET /lost/check_url?type={request|return}&type_id={id}
 */
export function checkLostUrl (type, type_id) {
  return request({
    url: '/lost/check_url',
    method: 'get',
    params: { type, type_id }
  })
}

/**
 * Farmaci disponibili nella req/ret di riferimento (per il popup drug della lost).
 * Se drug_id è passato, ritorna i lotti disponibili per quel farmaco.
 * GET /lost/ref_drugs/{type}/{type_id}[/{drug_id}]
 */
export function getRefDrugs ({ type, type_id, drug_id, search, id }) {
  if (!type || !type_id) return Promise.resolve({ data: [] })
  let url = `/lost/ref_drugs/${id}/${type}/${type_id}`
  if (drug_id) url += `/${drug_id}`
  return request({
    url,
    method: 'get',
    params: { search: search || undefined }
  })
}
